export const sites = {
  workspace: {
    assets: 'Assets',
    sites: "Sites",
  },
  list: {
    showAllSites: "Show all sites",
    emptyArchivedSub: "Sites you archive are kept here. Open one to restore it.",
    emptyArchivedTitle: "No archived sites",
    queueArchived: "Archived",
    title: "Sites",
    subtitle_one: '{{count}} location',
    subtitle_other: '{{count}} locations',
    searchPlaceholder: 'Search sites…',
    searchA11y: 'Search sites',
    refine: 'Refine',
    refineSheetTitle: 'Refine sites',
    addSite: 'Add site',
    queueAll: 'All',
    queueAttention: 'At risk',
    queueDevelopment: 'In development',
    // The card's next-action line. Plural-aware: these keys were missing, so the
    // untranslated defaults rendered "2 job in progress" — and called OPEN jobs
    // (the number the pill and the a11y label already call open) "in progress",
    // which a declined job is not.
    nextReviewAtRisk_one: 'Review {{count}} at-risk asset',
    nextReviewAtRisk_other: 'Review {{count}} at-risk assets',
    nextOpenJobs_one: '{{count}} open job',
    nextOpenJobs_other: '{{count}} open jobs',
    nextOpenChecks_one: '{{count}} open check',
    nextOpenChecks_other: '{{count}} open checks',
    a11yAssets_one: '{{count}} asset',
    a11yAssets_other: '{{count}} assets',
    emptyTitle: 'No sites yet',
    createSite: 'Create site',
    emptySub: 'Create a site to group assets by location or portfolio.',
    emptyFilterTitle: 'No matching sites',
    emptyFilterSub: 'Try different search terms or clear filters.',
    clearFilters: 'Clear filters',
    typeChip: 'Type',
    lifecycleChip: "Status",
    sortChip: 'Sort',
    sortNameAsc: 'Name A–Z',
    sortNameDesc: 'Name Z–A',
    sortNewest: 'Newest',
    sortOldest: 'Oldest',
    insightAttention: '{{count}} at risk',
    nextAllClear: 'No open work',
    nextAddAssets: 'Add assets to this site',
    pillAsset: 'asset',
    pillAssets: 'assets',
    pillOnTrack: 'On track',
    pillJobs: 'jobs',
    pillChecks: 'checks',
    exportCsv: 'Export CSV',
    exportCsvA11y: 'Download sites as CSV',
    viewCards: 'Card view',
    viewTable: 'Table view',
    openSite: 'Open site',
    unassigned: 'Unassigned',
    managingTeam: 'Managing team',
    colSite: 'Site',
    colType: 'Type',
    colTeam: 'Team',
    colAssets: 'Assets',
    colJobs: 'Jobs',
    colRisk: 'At risk',
    colStatus: 'Status',
    unknownSite: 'Unknown site',
    loadErrorTitle: "We couldn't load your sites",
    loadErrorBlockedTitle: "Sites can't be shown",
    viewLabel: 'View',
    scopeLabel: 'Scope',
    csvHeaderName: 'Name',
    csvHeaderCode: "Reference",
    csvHeaderLifecycle: "Status",
    csvHeaderAddress: 'Address',
  },
  detail: {
    byPlaceTitle: 'By building',
    byPlaceOpenA11y: 'Open {{name}}',
    byPlaceInside_one: '{{count}} inside',
    byPlaceInside_other: '{{count}} inside',
    byPlaceOpenJobs_one: '{{count}} open job',
    byPlaceOpenJobs_other: '{{count}} open jobs',
    byPlaceDue_one: '{{count}} visit due',
    byPlaceDue_other: '{{count}} visits due',
    byPlaceAtRisk_one: '{{count}} at high risk',
    byPlaceAtRisk_other: '{{count}} at high risk',
    noWorkNoAssets: "Work shows here once this site has assets. Add one, or move one here.",
    assignSubtitleTeam: "Pick an asset to move here. It leaves any other site and goes to {{team}}.",
    assignSubtitle: "Pick an asset to move here. It leaves any other site it's on.",
    assignFailedBody: "The asset was not moved. Check your connection and try again.",
    assignRefusedBody: "You can't move this asset. Ask the person who manages it, or an admin.",
    assignFailedTitle: "Asset not moved",
    assignedFallbackAsset: "The asset",
    assignedToast: "{{asset}} moved to {{site}}.",
    archivedBanner: "This site is archived and hidden from your sites. Restore it to use it again.",
    archivedPill: "Archived",
    restoredToast: "{{name}} restored. It's back in your sites.",
    archivedToast: "{{name}} archived. Find it under Archived on Sites.",
    loading: 'Loading site…',
    addAsset: 'Add asset',
    createAsset: 'Add asset',
    assignAsset: 'Assign asset',
    /** Empty-state CTA — spelled out, since there is room and no adjacent context. */
    assignExistingAsset: 'Assign an existing asset',
    /** Header "…" menu: site lifecycle, mirroring asset detail's Edit / Archive. */
    siteOptions: 'Site options',
    edit: 'Edit',
    tabOverview: 'Overview',
    tabDetails: 'Details',
    tabAssets: 'Assets',
    tabWork: 'Work',
    tabReports: "Reports",
    tabEsg: "ESG",
    tabContacts: "Contacts",
    tabActivity: 'Activity',
    tabPeople: "People",
    refine: "Refine",
    view: "View",
    viewList: "List",
    viewMap: "Map",
    viewNetwork: "Network",
    filterAttention: "Needs attention",
    backToOverview: "Back to Overview",
    kpiAssets: 'Assets',
    kpiAtRisk: 'At risk',
    kpiOpenJobs: 'Open jobs',
    kpiOpenInspections: 'Open inspections',
    parentSite: 'Parent site',
    childSites: 'Child sites',
    description: "Description",
    noAssets: 'No assets at this site.',
    noAssetsForFilter: 'No assets match this filter.',
    noWork: 'No open jobs or inspections.',
    noContacts: 'No contacts linked yet.',
    noContactsNeedAssets: 'Add assets before linking contacts.',
    noActivity: 'No recent activity.',
    linkContact: 'Link contact',
    selectAssetForContact: 'Select asset for contact',
    linkContactTitle: 'Link contact to site asset',
    cancel: 'Cancel',
    filterAll: 'All',
    openJobs: 'Open jobs',
    openInspections: 'Open inspections',
    attentionAssets_one: "{{count}} asset needs attention",
    attentionAssets_other: "{{count}} assets need attention",
    openJobsCount_one: "{{count}} open job",
    openJobsCount_other: "{{count}} open jobs",
    assetsSectionTitle: 'Assets at this site',
    assetsSectionSub_one: '{{count}} asset',
    assetsSectionSub_other: '{{count}} assets',
    filterVehicles: 'Vehicles',
    descriptionSummary: 'Site notes and context',
    workBannerNamed: 'Work scoped to {{names}}',
    contactsForAsset_one: '{{count}} contact',
    contactsForAsset_other: '{{count}} contacts',
    noContactsForAsset: 'No contacts linked to this asset yet.',
    archiveConfirmTitle: 'Archive this site?',
    archiveConfirmMessage: "It will be hidden from your sites. Assets stay where they are. You can find it under Archived on Sites and restore it.",
    archive: 'Archive',
    archiveFailedTitle: 'Could not archive site',
    archiveFailedMessage: "The site was not changed. Check your connection and try again.",
    restore: "Restore site",
    restoreFailedTitle: 'Could not restore site',
    loadErrorTitle: "We couldn't load this site",
    loadErrorBlockedTitle: "This site can't be shown",
    goBack: 'Go back',
    notFoundTitle: 'Site not found',
    notFoundBody: 'This site may have been archived, or the link is out of date.',
    noAssetsForSearch: 'No assets match your search',
    clearSearch: 'Clear search',
    searchAssetsPlaceholder: 'Search assets at this site',
    kpiAttention: 'Attention',
    kpiOpenChecks: "Open inspections",
    kpiAssetsInfoDescription: "Assets assigned to this site. Assets on its child sites are counted on those sites.",
    kpiAssetsInfoBasedOn_one: "{{count}} asset, counted live from the asset register",
    kpiAssetsInfoBasedOn_other: "{{count}} assets, counted live from the asset register",
    kpiAttentionInfoDescription: 'Assets at this site whose health is Watch or Poor, or that carry overdue work.',
    kpiAttentionInfoBasedOn: "{{count}} of {{total}} assets, from each asset's live health",
    kpiJobsInfoDescription: 'Jobs on assets at this site that are not yet completed or verified.',
    kpiJobsInfoBasedOn_one: "{{count}} open job across {{total}} assets",
    kpiJobsInfoBasedOn_other: "{{count}} open jobs across {{total}} assets",
    kpiChecksInfoDescription: 'Inspections on assets at this site that are still open: started and not completed, or scheduled and not yet done.',
    kpiChecksInfoBasedOn_one: "{{count}} open inspection across {{total}} assets",
    kpiChecksInfoBasedOn_other: "{{count}} open inspections across {{total}} assets",
    factsTitle: "Details",
    factCode: "Site code",
    factCategory: "Category",
    factType: "Type",
    factStatus: "Status",
    factAddress: "Address",
    factTeam: "Managing team",
    factContacts: "Contacts",
    factHolds: "Holds",
    factCreated: "Created",
    factUpdated: "Updated",
    factNotSet: "Not set",
    factViewOnMap: "View on map",
    tabDocuments: "Documents",
    factFloorArea: "Floor area",
    floorAreaValue: "{{value}} m²",
  },
  map: {
    unavailableSub: "The map could not load. Check your connection and try again.",
    addSiteAddress: "Add the site's address",
    noAssetsTitle: 'No assets at this site',
    noAssetsSub: 'Add assets to see them on the map.',
    noCoordinatesTitle: "Nothing on the map yet",
    noCoordinatesSub: "Add the site's address, or addresses on its assets, to see them here.",
    unavailableTitle: 'Map unavailable',
    coverageShown_one: "Showing {{count}} mapped asset.",
    coverageShown_other: "Showing {{count}} mapped assets.",
    coverageHidden_one: "{{count}} hidden without coordinates.",
    coverageHidden_other: "{{count}} hidden without coordinates.",
    boundarySaveFailedTitle: 'Could not save the boundary',
    boundarySaveFailedBody: 'The outline could not be saved.',
    boundaryRedraw: 'Redraw boundary',
    boundaryDraw: 'Draw boundary',
    boundaryRemove: 'Remove',
    boundarySave: 'Save boundary',
    boundaryUndo: 'Undo',
    boundaryTapFirstCorner: 'Tap the map to place the first corner',
    boundaryCornersAdjust: '{{count}} corners — drag any to adjust',
    boundaryCornersOfThree: '{{count}} of 3 corners',
  },
  network: {
    noAssetsTitle: 'No assets to connect',
    noAssetsSub: 'Add at least two assets to explore relationships.',
    singleAssetTitle: 'One asset at this site',
    singleAssetSub: 'Link this asset to others from its detail page to build a network.',
    openAsset: 'Open asset',
  },
  assetLink: {
    label: 'Site',
    helper: "The place this asset is kept.",
    none: 'No site assigned',
    open: 'Open site',
    rowHelper: "Optional. The place this asset is kept.",
    a11ySelected: 'Site: {{name}}. Change site.',
    a11yUnselected: 'Select site, optional',
    clearSite: 'Clear site',
    selectSite: 'Select site',
  },
  kind: {
    status: {
      decommissioned: "No longer used",
      under_renovation: "Being renovated",
      partially_operational: "Partly in use",
      operational: "In use",
      handover: "Being handed over",
      partially_developed: "Partly built",
      in_development: "Being built",
      planned: "Planned",
    },
    type: {
      other: "Other",
      building: "Building",
      corridor: "Route (road, rail or pipeline)",
      data_centre: "Data center",
      hotel: "Hotel",
      hospital: "Hospital",
      airport: "Airport",
      shopping_centre: "Shopping center",
      substation: "Substation",
      project_site: "Project site",
      construction_site: "Construction site",
      parking_facility: "Parking",
      terminal: "Terminal",
      port: "Port",
      distribution_centre: "Distribution center",
      warehouse: "Warehouse",
      workshop: "Workshop",
      fleet_hub: "Fleet hub",
      garage: "Garage",
      yard: "Yard",
      depot: "Depot",
      plant: "Plant",
      factory: "Factory",
      industrial_park: "Industrial park",
      office_building: "Office building",
      campus: "Campus",
      retail_park: "Retail park",
      business_park: "Business park",
      scheme: "Housing development",
      neighbourhood: "Neighborhood",
      estate: "Housing estate",
    },
    category: {
      other: "Other",
      mixed_use: "Mixed use",
      healthcare: "Healthcare",
      hospitality: "Hospitality",
      temporary: "Temporary / project",
      infrastructure: "Infrastructure",
      logistics: "Logistics & storage",
      fleet_transport: "Fleet & transport",
      industrial: "Industrial",
      commercial: "Commercial",
      residential: "Residential",
    },
    statusLabel: "Status",
    typeLabel: "Which fits best?",
    categoryLabel: "What kind of place is it?",
  },
  create: {
    createdBackToAsset: "{{name}} is created and chosen for your asset.",
    created: "{{name}} is created. Add its assets from here.",
    unsavedGuardMessage: "You haven't saved this site. Leave and lose what you typed?",
    pageTitle: 'New site',
    newSiteKicker: 'New site',
    unnamedSite: 'Unnamed site',
    addNotesFirstTitle: 'Add notes first',
    addNotesFirstBody: 'Type or dictate a short draft, then use Improve with AI.',
    improvedSiteNotesTitle: 'Improved site notes',
    unableToImproveNotesTitle: 'Unable to improve notes',
    improveNotesRationale: 'Review the improved notes before applying them to the site.',
    improveNotesFailed: 'Could not improve the notes. Please try again.',
    nameRequiredTitle: 'Name required',
    nameRequiredBody: "Type a name for the site.",
    invalidTypeTitle: "Pick the type again",
    invalidTypeBody: "That type doesn't fit the kind of place you chose. Pick one from the list.",
    createFailedTitle: 'Could not create site',
    createFailedBody: "The site was not created. Check your connection and try again.",
    labelType: "Type of site",
    labelLifecycle: "Status",
    labelParent: 'Parent',
    labelManagingTeam: 'Managing team',
    labelAddress: 'Address',
    labelName: 'Name',
    labelCode: "Reference",
    fallbackDash: '—',
    basicsNameLabel: 'Name *',
    siteNameA11y: 'Site name (required)',
    siteNamePlaceholder: 'e.g. Oakwood Estate',
    codeLabel: "Reference (optional)",
    codeHint: "Your own short code for this site, if you use one.",
    codeA11y: "Reference (optional)",
    codePlaceholder: "e.g. NDEP-01",
    parentSiteLabel: 'Parent site',
    parentSiteHelper: "Optional. Put it inside an estate, depot or campus.",
    managingTeamHelper: "Assets you add to this site go to this team.",
    addressLabel: 'Address (optional)',
    descriptionLabel: 'Description (optional)',
    descriptionA11y: 'Description (optional)',
    descriptionPlaceholder: 'Access notes, phase details, or handover context',
    dictate: 'Dictate',
    stopDictation: 'Stop',
    improving: 'Improving...',
    improveWithAi: 'Improve with AI',
    stepBasicsTitle: 'The basics',
    stepBasicsWhy: "Give the site a name. That's all you need; the rest is optional.",
    stepLocationTitle: 'Where is it?',
    stepLocationWhy: "Add the address so people can find it.",
    stepClassifyTitle: "Type of site",
    stepClassifyWhy: "Say what kind of place it is and whether it's in use.",
    stepStructureTitle: "Parent site and team",
    stepStructureWhy: "Put it inside a bigger site, and choose the team that looks after it.",
    saving: 'Saving…',
    createSite: 'Create site',
    parentSiteModalTitle: 'Parent site',
    managingTeamModalTitle: 'Managing team',
  },
  team: {
    managingTeam: 'Managing team',
    managingTeamHelper: 'Assets at this site inherit this team when added or when you change it here.',
    selectTeam: 'Select team',
    optional: 'Optional',
    pickerTitle: 'Managing team',
    noneAssigned: 'No team assigned',
    cascadeConfirmTitle: 'Update asset teams?',
    cascadeConfirmMessage_one: '{{count}} asset at this site will be reassigned to {{team}}.',
    cascadeConfirmMessage_other: '{{count}} assets at this site will be reassigned to {{team}}.',
    cascadeConfirmAction: 'Update team',
    updateFailedTitle: 'Could not update team',
    updateFailedMessage: 'Try again.',
    rowHelper: 'Assets added to this site inherit this team assignment.',
    a11ySelected: 'Managing team: {{name}}. Change team.',
    a11yUnselected: 'Select managing team, optional',
    clearTeam: 'Clear team',
  },
  picker: {
    dismissA11y: 'Dismiss site picker',
    closeA11y: 'Close site picker',
    searchPlaceholder: 'Search sites...',
    loadingSites: 'Loading sites',
    emptyResults: 'No sites found. Create one below or cancel to go back.',
    selectItemA11y: 'Select {{name}}',
  },
  report: {
    placeTitle: '{{place}} · {{site}}',
    generateFailedBody: "Something went wrong. Try again in a minute.",
    shareFailedTitle: "Could not save the report",
    shareGenerated: "Written by AI on {{date}}. Check it before you rely on it.",
    shareTitle: "Site report: {{name}}",
    pdfDocType: "Site report",
    pdfSummary: "Site summary",
    pdfType: "Type",
    pdfStatus: "Status",
    pdfTeam: "Managing team",
    pdfAddress: "Address",
    pdfAssetCount: "Assets",
    pdfAssetsHeading: "Assets at this site",
    pdfColAsset: "Asset",
    pdfColType: "Type",
    pdfColStatus: "Status",
    sharePdf: "Save or share as PDF",
    internetResearchHint: "Off: the report uses only your own records. On: it also searches the web, for example for recalls on this make and model.",
    internetResearchA11y: "Also look up public information online",
    internetResearch: "Also look up public information online",
    loadHistoryFailedTitle: 'Unable to load report history',
    unknownError: 'Unknown error',
    selectAnalysisTypeTitle: 'Select at least one analysis type',
    selectAnalysisTypeBody: 'Choose one or more sections before generating the report.',
    generateFailedTitle: "The site report was not generated",
    summaryPlaceholder:
      'Generate or load an advanced site report to see portfolio risk, health, compliance, and recommendations across every asset in this site.',
    actionSelectType: 'Select at least one analysis type.',
    actionGenerate: "Generate the site report.",
    analysisSiteOverview: 'Site overview',
    analysisAssets: 'Assets',
    analysisMaintenance: 'Maintenance',
    analysisRisk: 'Risk',
    analysisHealth: 'Health',
    analysisCompliance: 'Compliance',
    analysisComparisons: 'Comparisons',
    contextBadge: "AI report",
    fallbackTitle: 'Site report',
    metaKind: "AI report",
    heroTitle: 'Generate site report',
    heroSub: "AI writes a report from every asset at this site: inspections, jobs, documents and risk.",
    includeAnalysis: 'Include analysis',
    toggleAnalysisA11y: 'Toggle {{label}} analysis',
    generateButton: 'Generate report',
    snapshotComparison: "Earlier reports",
    latestSnapshotLine: 'Latest: {{date}}',
    previousSnapshotLine: 'Previous: {{date}}',
    noPreviousSnapshot: "No earlier report yet.",
    insightTitle: "Site report summary",
    signalRisk: 'Risk is {{level}} ({{score}}).',
    signalHealth: 'Health is {{status}} ({{score}}).',
    signalCompliance: 'Compliance is {{posture}} ({{score}}).',
    signalLatestSnapshot: "Last saved report: {{date}}.",
    signalNoSnapshot: "No report has been saved yet.",
    signalAnalysisSelected_one: '{{count}} analysis type is selected.',
    signalAnalysisSelected_other: '{{count}} analysis types are selected.',
    signalSnapshotsAvailable_one: "{{count}} saved report is available.",
    signalSnapshotsAvailable_other: "{{count}} saved reports are available.",
    signalNoSnapshotsAvailable: "No saved reports yet.",
    metricSnapshots: "Saved reports",
    sourceGenerated: "Written by AI",
    sourceSnapshot: "Last saved report",
    sourceSetup: "Not generated yet",
    executiveSummary: 'Executive summary',
    riskHealthCompliance: 'Risk / health / compliance',
    riskLine: 'Risk: {{level}} ({{score}})',
    healthLine: 'Health: {{status}} ({{score}})',
    complianceLine: 'Compliance: {{posture}} ({{score}})',
    maintenanceService: 'Maintenance & service',
    recommendations: 'Recommendations',
    recommendationLine: '- {{recommendation}}',
    noReportYet: "No site report yet. Tap Generate report.",
    sources: 'Sources',
    sourceLine: '- [{{sourceType}}] {{title}}',
  },
  edit: {
    parentLoopBody: "A site can't sit inside itself or inside one of its own sites.",
    parentLoopTitle: "Pick a different site",
    updateFailedBody: "Your changes were not saved. Check your connection and try again.",
    saved: "{{name}} saved.",
    pageTitle: 'Edit site',
    unsavedGuardMessage: 'You have unsaved edits to this site. Leave and lose them?',
    unsavedGuardDiscard: 'Leave',
    unsavedGuardKeep: 'Keep editing',
    updateFailedTitle: 'Could not update site',
    loadErrorTitle: "Couldn’t load this site",
    loadErrorWithMessage: '{{message}}. Check your connection and try again.',
    loadErrorGeneric: 'Check your connection and try again.',
    save: 'Save',
    archiveConfirmMessage: "It will be hidden from your sites. Assets stay where they are. You can find it under Archived on Sites and restore it.",
    siteNameA11y: 'Site name',
    codeA11y: 'Code',
    descriptionA11y: 'Description',
    archiveSite: 'Archive site',
    floorArea: "Floor area (m²)",
    floorAreaPlaceholder: "e.g. 2400",
    floorAreaHint: "Used for energy and carbon per m² in ESG. Leave blank if not known.",
    floorAreaInvalid: "Enter the floor area as a number of square metres.",
  },
  intake: {
    pageTitle: 'Report an issue',
    errorTitleMissing: 'Tell us what’s happening.',
    errorDescriptionMissing: 'Add a few details so the team can help.',
    errorNameMissing: 'Your name is required.',
    errorEmailInvalid: 'Enter a valid email address.',
    errorPhoneInvalid: 'Enter a valid phone number for the selected country.',
    errorContactMissing: 'Add an email or phone so the team can reply.',
    uploadFailed: "We couldn't upload your photos. Remove them or try again.",
    errorNotAvailable: "This link isn't accepting requests right now.",
    errorSubmitterDetailsRequired: 'Please add your name and an email or phone number.',
    errorSubmitGeneric: "We couldn't submit your request. Please try again.",
    contactLabel: 'Contact',
    addressLabel: 'Address',
    linkIncompleteTitle: 'Link incomplete',
    linkIncompleteBody: 'The link you opened is missing its asset reference. Try scanning the QR code again.',
    unavailableTitle: "This link isn't accepting requests",
    unavailableBody: "Reporting is switched off for this code, or the code is out of date. Tell the people who look after this place, for example reception or the site office.",
    sentTitle: 'Thanks — we got it',
    sentBody: "{{company}} has your report. They will contact you by email or phone if they need anything. You can close this page.",
    fallbackTeam: 'The team',
    reportAnother: 'Report another issue',
    reportAnotherA11y: 'Report another issue on this asset',
    beforeYouSend: 'Before you send',
    deflectTitle: 'This might fix it faster',
    deflectIntro_one:
      "We found a guide for this asset that may already answer your issue. Have a quick look — if it helps, you're sorted. If not, send your request below.",
    deflectIntro_other:
      "We found {{count}} guides for this asset that may already answer your issue. Have a quick look — if it helps, you're sorted. If not, send your request below.",
    kbFaq: 'FAQ',
    kbHowTo: 'HOW-TO',
    collapseGuideA11y: 'Collapse {{title}}',
    expandGuideA11y: 'Expand {{title}}',
    openFullGuide: 'Open the full guide',
    openGuideA11y: 'Open guide: {{title}}',
    stillSend: 'Still send my request',
    stillSendA11y: 'Send my request anyway',
    backToRequest: 'Back to my request',
    backToRequestA11y: 'Go back to edit my request',
    formTitle: "Tell us what's happening",
    introWithAsset: "You're reporting an issue with {{assetName}}. ",
    introBody: 'The team will see your message and get back to you — add your name and an email or phone so they can reach you.',
    fieldWhatsHappening: "What's happening?",
    titlePlaceholder: "One-line summary — e.g. 'no hot water in unit 3'",
    titleA11y: "What's happening (required)",
    fieldDetails: 'Details',
    detailsPlaceholder: "Describe the issue — what's wrong, where, and since when",
    detailsA11y: 'Details (required)',
    fieldPhotos: 'Photos',
    photosOptionalHint: '(optional, up to 2)',
    removePhotoA11y: 'Remove photo {{index}}',
    addPhotoA11y: 'Add a photo',
    addPhotoLabel: 'Add photo',
    fieldYourName: 'Your name',
    namePlaceholder: "So they know who they're helping",
    nameA11y: 'Your name (required)',
    fieldEmail: 'Email',
    emailPlaceholder: 'So they can reply',
    fieldPhone: 'Phone',
    phonePlaceholder: 'In case they need to call',
    contactHint: "We'll only use this to reply about your report.",
    sending: 'Sending…',
    checkingFix: 'Checking for a quick fix…',
    sendRequest: 'Send request',
  },
  knowledge: {
    goToAssets: "Go to assets",
    backButton: 'Back',
    title: 'Knowledge',
    subtitle: 'Search across your assets',
    unknownAsset: 'Unknown asset',
    anyAsset: 'Any asset',
    moreAssetsSummary: '{{first}}, {{second}} +{{count}} more',
    openItemA11y: 'Open {{title}}, {{kind}} on {{asset}}',
    untitledItemA11y: 'knowledge item',
    untitled: 'Untitled',
    searchPlaceholder: "Search knowledge",
    refineResults: 'Refine results',
    refineTypeLabel: 'Type',
    refineAssetLabel: 'Asset',
    assetSummaryA11y: 'Asset: {{summary}}',
    removeAssetA11y: 'Remove {{name}}',
    signInTitle: 'Sign in to search your knowledge',
    signInBody: 'Your session has expired, so nothing could be searched. Sign in again to continue.',
    searchErrorTitle: "Couldn’t run that search",
    tryAgain: 'Try again',
    noMatchesTitle: 'No matches',
    noMatchesBody: "Nothing matched. Try different words, or add it: open the asset, go to Knowledge and tap Add.",
    noFilterMatchesTitle: 'Nothing matches these filters',
    filteredEmptyBody_one: '{{count}} result matched the search but none match the asset or type you chose.',
    filteredEmptyBody_other: '{{count}} results matched the search but none match the asset or type you chose.',
    introTitle: 'Search your knowledge base',
    introBody: "Find how-tos, FAQs, notes, files and links across every asset. Type at least two letters. To add knowledge, open an asset, go to Knowledge and tap Add.",
    shareOpenLinkFailedTitle: 'Could not open link',
    shareInvalidLink: 'Invalid link',
    shareTimeoutMessage: 'This shared library is taking too long to load. Check your connection and try again.',
    shareLoadFailed: 'Could not load shared knowledge',
    shareUnableToLoad: 'Unable to load',
    shareEmptyTitle: 'Nothing to show',
    shareEmptyBody: 'This share may have been revoked, or no articles have been published to it yet.',
    shareOpenLink: 'Open link',
    shareOpenFile: 'Open file',
    shareClose: 'Close',
  },
  documents: {
    title: "Site documents",
    sub: "Documents for the whole building, such as its EPC or DEC. Asset documents stay on each asset.",
    add: "Add document",
    open: "Open",
    edit: "Edit",
    archive: "Archive",
    cancel: "Cancel",
    archiveTitle: "Archive this document?",
    archiveBody: "{{title}} leaves this list. Its file and history are kept.",
    archiveFailed: "Could not archive the document. Try again.",
    loadFailed: "Could not load the documents.",
    retry: "Try again",
    emptyTitle: "No site documents yet",
    emptyBody: "Add the building's certificates here, such as its EPC or DEC.",
    validUntil: "Valid until {{date}}",
    expired: "Expired {{date}}",
  },
} as const;
